import React from 'react';
import { Row, Col } from "react-bootstrap";
import AniCard from '../AniCard';
import CustomCard from '../CustomCard';

import Diary from '../../../assets/images/BusinessSection/Diary.jpg';
import Stickers from '../../../assets/images/BusinessSection/BusinessStickers.jpg';
import Notepad from '../../../assets/images/BusinessSection/Notepad.jpg';
import Envelop from '../../../assets/images/BusinessSection/Envelops.avif';
import EnvelopB from '../../../assets/images/BusinessSection/EnvelopBack.avif';
import Pad from '../../../assets/images/BusinessSection/MousePad.jpg';
import Stamp from '../../../assets/images/BusinessSection/SelfInkStamp.webp';

// Card Data
const cardData = [
    { image: Diary, text: "Office Diaries" },
    { image: Stickers, text: "Stickers" },
    { image: Notepad, text: "Content for card 3" },
    { image: Envelop, text: "Envelops" },
    { image: EnvelopB, text: "Envelops" },
    { image: Pad, text: "Mouse Pads" },
    { image: Stamp, text: "Instant Self Ink Stamps" },
];

function Office() {
    return (
        <>
            <div>
                <h2 className='py-4 fw-bold text-center'>Office Stationary</h2>
                {/* 1st row */}
                <Row>
                    {cardData.slice(0, 3).map((card, index) => (
                        <Col md={4} className="d-flex" key={index}>
                            <CustomCard image={card.image} text={card.text} />
                        </Col>
                    ))}
                </Row>

                {/* 2nd row */}
                <Row>
                    <Col md={12} className="d-flex">
                        <AniCard image={Envelop} imageHover={EnvelopB} text="Envelops" />
                    </Col>
                </Row>

                {/* 3rd row */}
                <Row>
                    {cardData.slice(5, 7).map((card, index) => (
                        <Col md={6} className="d-flex" key={index}>
                            <CustomCard image={card.image} text={card.text} />
                        </Col>
                    ))}
                </Row>

                {/* Divider-line */}
                <hr className="divider-line" style={{ margin: '0 auto' }} />
            </div>
        </>
    );
}

export default Office;